import React from 'react';
import '../App.css';
import { useState } from "react";
import AdminUsersTab from '../components/AdminUsersTab.js';
import AdminDataTab from '../components/AdminDataTab.js';
import AdminControlTab from '../components/AdminControlTab.js';

export const Portal = () => {
    const [activeTab, setActiveTab] = useState('USERS');
    


    return (
		<div className='container-fluid m-0 p-0'>
			<div>
				<div className='row'>
					<div className='col-12 col-md-5' id="infiniteScrollContainer" style={{flexGrow: 1, padding: 0}}> 
						<div className="d-flex justify-content-between align-items-center px-4 rounded">
							<div>
								<div className='d-flex gap-2'>
                                    <button className='btn btn-outline-success' onClick={() => setActiveTab('USERS')}>Users</button>
                                    <button className='btn btn-outline-success' onClick={() => setActiveTab('DATA')}>Data</button>
                                    <button className='btn btn-outline-success' onClick={() => setActiveTab('CONTROL')}>Control</button>
                                </div>
							</div>
						</div>

                        <div>
                            {activeTab === 'USERS' && <AdminUsersTab />}
                            {activeTab === 'DATA' && <AdminDataTab />}
                            {activeTab === 'CONTROL' && <AdminControlTab />}
                        </div>
					</div>
				</div>
			</div>
		</div>
	);
}